/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Tc_Generic_PlaceholderInputs */



/**
* | output |
* | --- |
* | "SMPTE Timecode" |
*
* @param {Input_Tc_Generic_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_generic_placeholder = /** @type {((inputs?: Input_Tc_Generic_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Generic_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecode SMPTE")
	if (locale === "de") return /** @type {LocalizedString} */ ("SMPTE-Zeitcode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice temporale SMPTE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Временной код SMPTE")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de tiempo SMPTE")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SMPTE 时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SMPTEタイムコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसएमपीटीई टाइमकोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de tempo SMPTE")
	return /** @type {LocalizedString} */ ("SMPTE Timecode")
});